import { createContext, Dispatch, SetStateAction, useContext } from "react";

interface CalendlyContextType {
	calendlyIsOpened?: boolean;
	setCalendlyIsOpened: Dispatch<SetStateAction<boolean>>
}

export const CalendlyContext = createContext<CalendlyContextType | null>(null);

const useCalendly = () => {
	const calendlyContext = useContext(CalendlyContext);

	if (!calendlyContext) {
		throw new Error(
			"useCalendly has to be used within <CalendlyContext.Provider>"
		);
	}

	return calendlyContext;
};

export default useCalendly